import { Component } from '@angular/core';

import { IonicPage, NavController, NavParams,LoadingController,Slides,Events,Platform,AlertController } from 'ionic-angular';

import { Http } from '@angular/http';
import { MenuController } from 'ionic-angular';
import { Commontask } from '../../providers/commontask'
import { Webservice } from '../../providers/webservice'
import { Storagehelper } from '../../providers/storagehelper'
import { SocialSharing } from '@ionic-native/social-sharing';
import {NewreminderPage} from '../newreminder/newreminder';
import { DeletereminderPage } from '../deletereminder/deletereminder';
import { LocalNotifications } from '@ionic-native/local-notifications';
/**
/**
 * Generated class for the ReminderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-reminder',
  templateUrl: 'reminder.html',
})
export class ReminderPage extends Commontask {
	public textproperty;
	public reminderSetting;
  public reminders;
  private setttingData;
  constructor(public navCtrl: NavController, public navParams: NavParams,public menuctrl: MenuController,public http:Http,public webservice:Webservice,public loader:LoadingController,public storage:Storagehelper,public event:Events,public alertCtrl:AlertController,public platform:Platform,public socialShare:SocialSharing,public localnotifcation:LocalNotifications) {
  		super(menuctrl,event,platform,socialShare,alertCtrl);
      this.reminders=[];
      this.getMenuTitle();
    	this.textproperty={bck:"",title:"",menu_category:-1};
    	this.reminderSetting={state:true,extraclass:'reminder-activated'};
      this.setttingData={reminderSetting:true};
      this.getAllReminders();
      this.checkremindersetting();

  }

  updateReminderSetting(){
  	if(this.reminderSetting.state==true){
  		this.reminderSetting.extraclass="reminder-activated";
  	}else{
  		this.reminderSetting.extraclass="reminder-deactivated";
  	}
    this.setttingData.reminderSetting=this.reminderSetting.state;
    this.storage.updateItem("setting","setting_id",this.setttingData.setting_id,this.setttingData);
  }

  checkremindersetting(){
    this.storage.getStorageItem("setting").then(data=>{
      if(data==undefined){
        var param={reminderSetting:this.reminderSetting.state};
        this.storage.addNewItem("setting","setting_id",param);
      }else{
        var setting=data[0];
        this.setttingData=setting;
        if(setting.reminderSetting!=undefined){
          this.reminderSetting.state=setting.reminderSetting;
        }
      }
    })
  }

  updateReminder(reminder){
    if(this.reminderSetting.state==true){
      this.navCtrl.push(NewreminderPage,{
        reminderid:reminder.reminder_id,
        remindertype:'update'
      })
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReminderPage');


  }

  getAllReminders(){
    this.storage.getStorageItem('reminders').then((data)=>{
      this.reminders=data;
    })
  }


  getMenuTitle(){
    this.storage.getStorageItem("staticTexts").then(menuTexts=>{    
             var bck=menuTexts.filter((e,i)=>{
               return e.textid==6;
             });
             if(bck.length>0){
               this.textproperty.bck=bck[0].menuBackground;
               this.textproperty.title=bck[0].staticText;
             }
             
         })
  }

  addNewReminder(){

    if(this.reminderSetting.state==true){
    	this.navCtrl.push(NewreminderPage,{
          remindertype:'create'
      })
    }
  }

  deleteReminder(){
    this.navCtrl.push(DeletereminderPage);
  }


  deleteThisReminder(item){
      this.confirmDelete().then((result)=>{
       if(result==true){
           this.storage.deleteItem("reminders","reminder_id",item.reminder_id).then((data)=>{
             this.unscheduleReminder(this.localnotifcation,item.reminder_id);
              this.getAllReminders();
            })
       }
     });
  }

 
   ionViewDidEnter(){
    // if(this.audioplayer.src!=""){
    //   this.Play();
    // }
    this.event.publish('app:changeHeaderBackground'); 
  }

  ionViewCanEnter(){

    this.event.publish('app:changeHeaderBackground'); 
  }

  ionViewWillEnter(){
    this.getAllReminders();
    this.event.publish('app:changeHeaderBackground'); 
  }

}



// WEBPACK FOOTER //
// ./src/pages/reminder/reminder.ts